module.exports = __webpack_public_path__ + "media/SetB_T1_B.6f0fbe4e.mp3";